import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg width="32" height="34" viewBox="0 0 32 34" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.5 0.5H28C29.933 0.5 31.5 2.067 31.5 4V30C31.5 31.933 29.933 33.5 28 33.5H0.5V0.5Z"
          stroke="currentColor"
        />
        <path
          d="M9.56227 12.2304C9.25659 12.3308 9.25659 12.7635 9.56227 12.8644C10.2668 13.0959 10.8194 13.6489 11.0514 14.3535C11.1522 14.6591 11.5845 14.6591 11.6853 14.3535C11.9169 13.6489 12.4699 13.0964 13.1744 12.8644C13.4805 12.7635 13.4805 12.3312 13.1744 12.2304C12.4699 11.9989 11.9173 11.4458 11.6853 10.7413C11.5849 10.4352 11.1522 10.4352 11.0514 10.7413C10.8198 11.4463 10.2668 11.9989 9.56227 12.2304ZM19.2619 11.7117C19.1425 11.3491 18.6297 11.3491 18.5103 11.7117L17.9523 13.4088C17.6774 14.2445 17.0221 14.8997 16.1865 15.1746L14.4898 15.7327C14.1272 15.852 14.1272 16.3653 14.4898 16.4842L16.1869 17.0422C17.0226 17.3171 17.6778 17.9724 17.9528 18.808L18.5108 20.5047C18.6301 20.8673 19.1434 20.8673 19.2623 20.5047L19.8203 18.808C20.0953 17.9724 20.7505 17.3171 21.5861 17.0422L23.2832 16.4842C23.6459 16.3648 23.6459 15.8516 23.2832 15.7327L21.5861 15.1746C20.7505 14.8997 20.0953 14.2445 19.8203 13.4088L19.2619 11.7117ZM13.3268 18.8338C13.2074 18.4711 12.6946 18.4711 12.5752 18.8338L12.507 19.0418C12.232 19.8775 11.5768 20.5327 10.7411 20.8076L10.5331 20.8759C10.1705 20.9953 10.1705 21.5085 10.5331 21.6275L10.7411 21.6958C11.5768 21.9707 12.232 22.6259 12.507 23.4616L12.5752 23.6696C12.6946 24.0322 13.2079 24.0322 13.3268 23.6696L13.3951 23.4616C13.67 22.6259 14.3252 21.9707 15.1609 21.6958L15.3689 21.6275C15.7316 21.5081 15.7316 20.9949 15.3689 20.8759L15.1609 20.8076C14.3252 20.5327 13.67 19.8775 13.3951 19.0418L13.3268 18.8338Z"
          fill="url(#paint0_linear_10164_9205)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_10164_9205"
            x1="13.4243"
            y1="26.4155"
            x2="35.3405"
            y2="22.4726"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#5B01FF" />
            <stop offset="1" stop-color="#FA00FF" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
